import { init as initApm } from '@elastic/apm-rum';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import ResizeObserver from 'resize-observer-polyfill';
import App from './App';
import config from './config';
import './font.css';
import './index.css';
import V2GlobalStyles from './themes/v2/V2GlobalStyles';
import lightTheme from './themes/v2/light.theme';
import {
  redirectToRootBroadcastMessage,
  reloadAppBroadcastChannel,
  reloadAppBroadcastMessage,
} from './utils/resetApp.util';

const APP_ENV = import.meta.env.VITE_APP_ENV;
const IS_DEPLOYED_ENV = APP_ENV === 'production' || APP_ENV === 'homolog';

if (IS_DEPLOYED_ENV) {
  initApm({
    serviceName: 'teceo-web',
    serverUrl: config.apmURL,
    environment: APP_ENV,
    serviceVersion: import.meta.env.VITE_APP_VERSION,
    distributedTracingOrigins: [config.baseURL],
    propagateTracestate: true,
  });
}

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

const muiCache = createCache({
  key: 'mui',
  prepend: true,
});

reloadAppBroadcastChannel.onmessage = (event) => {
  if (event.data === reloadAppBroadcastMessage) {
    window.location.reload();
    return;
  }
  if (event.data === redirectToRootBroadcastMessage) {
    window.location.assign('/');
  }
};

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <CacheProvider value={muiCache}>
      <ThemeProvider theme={lightTheme}>
        <V2GlobalStyles />
        <App />
      </ThemeProvider>
    </CacheProvider>
  </StrictMode>,
);
